import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AppRouter } from './routing/router';
import { AuthProvider } from './authentication/authContext';


const root = document.getElementById('root');

ReactDOM.createRoot(root)
  .render(
    <div className="App">
      <header className="App-header">
        <React.StrictMode>
            <AppRouter />
        </React.StrictMode>
      </header>
    </div>
  );


